export const POINTS = [
  'N',
  'NNE',
  'NE',
  'ENE',
  'E',
  'ESE',
  'SE',
  'SSE',
  'S',
  'SSW',
  'SW',
  'WSW',
  'W',
  'WNW',
  'NW',
  'NNW',
]

const normalize = degrees => ((degrees % 360) + 360) % 360

export const directionPoint = degrees => {
  if (degrees == null) return
  return POINTS[Math.round(normalize(degrees) / 22.5) % 16]
}
